
import Client from 'esdk-obs-browserjs'
export function getObsClient(option:any){
    const obsClient = new Client({
        access_key_id: option.ak,
        secret_access_key: option.sk,
        security_token:option.securityToken,
        server : option.server,
        timeout :option.timeout,
    })
    return obsClient
}
export function getColors(){
    const colors= ['#4680f5', '#54b8b4', '#c17bfd','#ac5b6d','#fbeb63','#4fc971']
    return colors
}
//获取时间戳
export function getTimestamp(){
    return new Date().getTime()
}
/**
 * 获取url中的对应参数值
 * @param name
 * @returns {*}
 */
 export function getQueryString(name?: string, url?: string) {
    const reg = new RegExp('(^|&)' + name + '=([^&]*)(&|$)', 'i')
    const search = url?.split('?')[1] || ''
    const r = search.match(reg) || []
    return r[2]
  }
// 获取localstorage 存值
export function getLocalItem(key:string){
    return JSON.parse(localStorage.getItem(key) as any)||''
}
//删除Localstorage
export function removeItem(key:string){
    localStorage.removeItem(key)
}
//blob 下载
export  function downLoadBlobFN(result:any,option:any={type:'',name:''}){
    const {type}=option
    if (window.navigator && window.navigator.msSaveOrOpenBlob) {
        window.navigator.msSaveOrOpenBlob(new Blob([result]))
    } else {
        const url = window.URL.createObjectURL(new Blob([result], {
             type:type
        }))
        const a = document.createElement('a')
        a.style.display = 'none'
        a.href = url
        if(option.name){
          a.setAttribute('download', option.name)
        }
        document.body.appendChild(a)
        a.click()
        document.body.removeChild(a)
        window.URL.revokeObjectURL(url)
    }
}
//通过url下载
export function downLoadURlFN (url: string, option: {name: string}){
	const a = document.createElement('a')
	a.style.display = 'none'
    a.href = url
    if(option.name){
         a.setAttribute('download',option.name)
    }
	document.body.appendChild(a)
	a.click()
	document.body.removeChild(a) 
}
//获取时间字符串
export function getCurTimeStr(){
	let timeStr=''
	const data = new Date()
	const year   =  data.getFullYear().toString()
	const month  =  (data.getMonth()+1)<10?('0'+(data.getMonth()+1)):(data.getMonth()+1)  
	const day    =  data.getDate()<10?('0'+data.getDate()):data.getDate() 
	const hour   =  data.getHours()
	const minute =  data.getMinutes()
	const second =  data.getSeconds()
	return timeStr = year + month + day + hour+ minute + second
}